module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "max-width": "400px"
    },
    model: {
      value: (_vm.cancelWarningModal),
      callback: function($$v) {
        _vm.cancelWarningModal = $$v
      },
      expression: "cancelWarningModal"
    }
  }, [_c('span', {
    staticClass: "link",
    attrs: {
      "slot": "activator"
    },
    slot: "activator"
  }, [_vm._t("default")], 2), _vm._v(" "), _c('v-card', [_c('v-card-title', [_c('v-flex', [_c('span', {
    staticClass: "headline-20"
  }, [_vm._v("Qual foi o motivo do cancelamento?")])]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-right"
  }, [_c('v-btn', {
    staticClass: "ma-0",
    attrs: {
      "icon": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.cancelWarningModal = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1)], 1), _vm._v(" "), _c('v-card-text', [_c('p', {
    staticStyle: {
      "font-size": "16px"
    }
  }, [_vm._v("Escolha um motivo para o cancelamento")]), _vm._v(" "), _c('v-radio-group', {
    attrs: {
      "mandatory": false
    },
    model: {
      value: (_vm.reason),
      callback: function($$v) {
        _vm.reason = $$v
      },
      expression: "reason"
    }
  }, _vm._l((_vm.reasons), function(reason) {
    return _c('v-radio', {
      key: reason.id,
      attrs: {
        "color": "red",
        "label": reason.description,
        "value": reason.id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "blue--text darken-1",
    attrs: {
      "flat": "flat",
      "disabled": _vm.reason === null
    },
    nativeOn: {
      "click": function($event) {
        return _vm.cancelSchedule($event)
      }
    }
  }, [_vm._v("Sim, desejo cancelar")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3669228a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/painel/agendamento/cancelWarning.vue
// module id = 507
// module chunks = 0 1